import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { RequestJoinSocietyForm } from '../RequestiJoinSocietyForm'
import { PendingRequest } from '../PendingRequest'
import { InactiveSociety } from '../InactiveSociety'
import { ISocietiesModel } from '../../../../interfaces/models/societies.interfaces'
import { requestQueries } from '../../../../api/requests'
import { useAuth } from '../../../../hooks/useAuth'

interface FindSocietyContentProps {
  society: ISocietiesModel
}

export const FindSocietyContent = ({
  society,
}: FindSocietyContentProps): React.ReactNode => {
  const { userId } = useAuth()
  const societyIsActive = society.status === 'active'

  const { data: userRequests } = useQuery(
    requestQueries.getRequestsPerUser(userId)
  )

  const userRequestForSociety =
    userRequests?.filter((request) => request.societyId === society._id) || []
  const userHasPendingRequest = userRequestForSociety.length > 0

  if (userHasPendingRequest) return <PendingRequest />

  if (societyIsActive)
    return <>{society && <RequestJoinSocietyForm society={society} />}</>

  return <>{society && <InactiveSociety society={society} />}</>
}
